import ScheduleForm from 'components/ScheduleForm'
import React, { useEffect, useState } from 'react'
import { interpreterSelector } from 'slices/interpreterSlice';
import { fetchInterpreters } from 'slices/interpreterSlice';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import { Select } from 'components/common/Select';
import ErrorMessage from 'components/common/ErrorMessage';
import { actionButtonsSelector } from 'slices/actionButtonSlice';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { Controller, useForm } from 'react-hook-form';
import { CustomSwitch } from 'components/common/Switch';

export const commentOptions = [
    {
        label: "Adminssion/Intake",
        value: "Admission/Intake"
    },
    {
        label: "Discharge",
        value: "Discharge"
    },
    {
        label: "Informed Consent",
        value: "Informed Consent"
    },
    {
        label: "Service Decline",
        value: "Service Decline"
    },
    {
        label: "Other",
        value: "Other"
    }
]
export const CheckinCheckoutAdjustmentModal = ({ isOpen, item, appointmentId, onSubmit, handleClose, onClose, loader, requireAttestation = false }) => {
    console.log("itemssss", item)
    const dispatch = useDispatch();
    // const { loader, error } = useSelector(actionButtonsSelector)
    const methods = useForm({
        defaultValues: {
            options: "current_time",
            checkin_date: moment().format("YYYY-MM-DD"),
            checkin_time: moment().format("HH:mm"),
            checkout_date: moment().format("YYYY-MM-DD"),
            checkout_time: moment().add(15).format("HH:mm"),
        }

    });
    const { setFocus, handleSubmit, watch, formState: { errors }, control, setValue, setError: setErrors, reset } = methods


    const refCloseScheduleButton = React.useRef(null);

    const handleCloseScheduleForm = () => {
        refCloseScheduleButton.current.click();
        reset();
        localStorage.removeItem("selected_schedule_item");

        shutDownModal();
    };;


    const shutDownModal = () => {
        setTimeout(() => {
            onClose && onClose()
            handleClose && handleClose()
        }, 200);
    }
   
    useEffect(() => {
        let checkinDate = moment().format("YYYY-MM-DD");
        let checkinTime = moment().format("HH:mm");
        let checkoutDate = moment().format("YYYY-MM-DD");
        let checkoutTime = moment().add(15, "minutes").format("HH:mm");
        console.log(item, 'itemsss');
        if (
        item?.appointment_assign?.checkin_date &&
        item?.appointment_assign?.checkin_time &&
        item?.appointment_assign?.checkout_date &&
        item?.appointment_assign?.checkout_time
        ) {
        checkinDate = item.appointment_assign.checkin_date;
        checkinTime = item.appointment_assign.checkin_time;
        checkoutDate = item.appointment_assign.checkout_date;
        checkoutTime = item.appointment_assign.checkout_time;
        } else if (
        item?.details?.appointment_assign?.checkin_date &&
        item?.details?.appointment_assign?.checkin_time &&
        item?.details?.appointment_assign?.checkout_date &&
        item?.details?.appointment_assign?.checkout_time
        ) {
        checkinDate = item.details.appointment_assign.checkin_date;
        checkinTime = item.details.appointment_assign.checkin_time;
        checkoutDate = item.details.appointment_assign.checkout_date;
        checkoutTime = item.details.appointment_assign.checkout_time;
        } else {
        var checkTime = item?.details?.datetime ? item?.details?.datetime : item?.datetime;
        var checkDuration = item?.details?.duration ? item?.details?.duration : item?.duration;
        if (checkTime && checkDuration) {
            const start = moment(checkTime);
            const end = moment(checkTime).add(checkDuration, "minutes");

            checkinDate = start.format("YYYY-MM-DD");
            checkinTime = start.format("HH:mm");
            checkoutDate = end.format("YYYY-MM-DD");
            checkoutTime = end.format("HH:mm");
        }
        }

        setValue("checkin_date", checkinDate);
        setValue("checkin_time", checkinTime);
        setValue("checkout_date", checkoutDate);
        setValue("checkout_time", checkoutTime);

        // setValue("comments", item?.details?.appointment_assign?.comments || commentOptions[0]);
        setValue("comments", item?.details?.appointment_assign?.comments || "");
        setValue("notes", item?.details?.appointment_assign?.notes || "");
        setValue("travel_fee_amount", item?.travel_fee || 0);
        setValue("travel_approved", item?.travel_approved);
    }, [item, isOpen]);

    return (
        <div className="modal fade" id="checkinCheckoutAdjustmentModal" tabindex="-1" aria-labelledby="checkinCheckoutAdjustmentModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-lg" style={{ background: 'transparent' }}>
                <div className="modal-content full_modal">
                    <div className="modal-header header_modal align-items-center">
                        <div></div>
                        <h5 className="modal-title_u">Check In / Out Adjustment</h5>
                        <button type="button" onClick={handleCloseScheduleForm} className="btn-close" ref={refCloseScheduleButton} data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body modal_form_body">
                        <div className='row-primary flex-column gap-0 mb-3'>
                            <h2 className='fst-italic mb-2'>Check In Adjustment</h2>
                            <div className='row-primary row-r'>
                                <div className="date">
                                    <h2>Date*</h2>
                                    <Controller
                                        name="checkin_date"
                                        control={control}
                                        rules={{

                                            required: "Please select a Date"
                                        }
                                        }
                                        render={({ field }) =>
                                            <div style={{ width: "100%" }}>
                                                <div className="input-image">
                                                    <input id='date' type="date" name='checkin_date'
                                                        placeholder='YYYY-MM-DD' required

                                                        {...field}
                                                        value={field.value ? moment(field.value).format('YYYY-MM-DD') : ""}
                                                        onChange={(e) => {
                                                            const dateString = moment.utc(e.target.value).format('YYYY-MM-DD')
                                                            field.onChange(dateString)
                                                        }}
                                                    />
                                                    <img src="/images/celender.png" alt="celender Icon" className="custom-icon" />

                                                </div>
                                                {errors?.checkin_date?.message &&
                                                    <div style={{ marginBottom: 10 }}>
                                                        <ErrorMessage text={errors?.checkin_date?.message} />
                                                    </div>
                                                }
                                            </div>
                                        } />
                                </div>

                                <div className="time">
                                    <h2>Time*</h2>
                                    <Controller
                                        name="checkin_time"
                                        control={control}
                                        rules={{

                                            required: "Please select a Time"
                                        }
                                        }
                                        render={({ field }) =>
                                            <div style={{ width: "100%" }}>
                                                <div className="input-image">
                                                    <input id='checkin_time' type="time" name='checkin_time'
                                                        placeholder='HH:MM:SS' required
                                                        {...field}
                                                        value={field.value ? moment(field.value, ["h:mm A"]).format("HH:mm") : ""}
                                                        onChange={(e) => {
                                                            const timeString = moment(new Date()).set({ hour: parseInt(e.target.value.slice(0, 2)), minute: parseInt(e.target.value.slice(3, 5)) }).format('HH:mm:ss')
                                                            field.onChange(timeString)
                                                        }}
                                                    />
                                                    <img src="/images/clock.png" alt="celender Icon" className="custom-icon" />
                                                    {errors?.checkin_time?.message &&
                                                        <div style={{ marginBottom: 10 }}>
                                                            <ErrorMessage text={errors?.checkin_time?.message} />
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        }
                                    />

                                </div>
                            </div>
                        </div>

                        <div className='row-primary flex-column gap-0 mb-3'>
                            <h2 className='fst-italic mb-2'>Check Out Adjustment</h2>
                            <div className='row-primary row-r'>
                                <div className="date">
                                    <h2>Date*</h2>
                                    <Controller
                                        name="checkout_date"
                                        control={control}
                                        rules={{

                                            required: "Please select a Date"
                                        }
                                        }
                                        render={({ field }) =>
                                            <div style={{ width: "100%" }}>
                                                <div className="input-image">
                                                    <input id='checkout_date' type="date" name='checkout_date'
                                                        placeholder='YYYY-MM-DD' required

                                                        {...field}
                                                        value={field.value ? moment(field.value).format('YYYY-MM-DD') : ""}
                                                        onChange={(e) => {
                                                            const dateString = moment.utc(e.target.value).format('YYYY-MM-DD')
                                                            field.onChange(dateString)
                                                        }}
                                                    />
                                                    <img src="/images/celender.png" alt="celender Icon" className="custom-icon" />

                                                </div>
                                                {errors?.checkout_date?.message &&
                                                    <div style={{ marginBottom: 10 }}>
                                                        <ErrorMessage text={errors?.checkout_date?.message} />
                                                    </div>
                                                }
                                            </div>
                                        } />

                                </div>

                                <div className="time">
                                    <h2>Time*</h2>
                                    <Controller
                                        name="checkout_time"
                                        control={control}
                                        rules={{

                                            required: "Please select a Time"
                                        }
                                        }
                                        render={({ field }) =>
                                            <div style={{ width: "100%" }}>
                                                <div className="input-image">
                                                    <input id='checkout_time' type="time" name='checkout_time'
                                                        placeholder='HH:MM:SS' required
                                                        {...field}
                                                        value={field.value ? moment(field.value, ["h:mm A"]).format("HH:mm") : ""}
                                                        onChange={(e) => {
                                                            const timeString = moment(new Date()).set({ hour: parseInt(e.target.value.slice(0, 2)), minute: parseInt(e.target.value.slice(3, 5)) }).format('HH:mm:ss')
                                                            field.onChange(timeString)
                                                        }}
                                                    />
                                                    <img src="/images/clock.png" alt="celender Icon" className="custom-icon" />
                                                    {errors?.checkout_time?.message &&
                                                        <div style={{ marginBottom: 10 }}>
                                                            <ErrorMessage text={errors?.checkout_time?.message} />
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        }
                                    />

                                </div>
                            </div>
                        </div>

                        {/* Comments */}
                        {/* <div className="row-primary mb-3">
                            <h2>Comments*</h2>
                            <Controller
                                name="comments"
                                control={control}
                                rules={{
                                    required: "Please select a comment"
                                }}
                                render={({ field }) =>
                                    <div style={{ width: "100%" }}>
                                        <Select
                                            name="comments"
                                            options={commentOptions || []}
                                            value={field.value ? commentOptions?.find((opt) => field.value == opt.value) : null}
                                            isClearable={false}
                                            disabledSearch={true}
                                            onChange={(value) => {
                                                field.onChange(value);
                                            }}


                                        />

                                        {errors?.comments?.message &&
                                            <div style={{ marginBottom: 10 }}>
                                                <ErrorMessage text={errors?.comments?.message} />
                                            </div>
                                        }

                                    </div>
                                }
                            />
                        </div> */}

                        <div className="row-primary mb-3">
                            <h2>Notes</h2>
                            <Controller
                                name="notes"
                                control={control}
                                render={({ field }) =>
                                    <textarea
                                        className="type_inp input-in"
                                        {...field}
                                        placeholder='Enter notes or additional comments'
                                    >
                                    </textarea>
                                }

                            />
                        </div>

                        {item?.adjust_modal && (
                            <>
                                <div className="row-primary">
                                    <h2>Travel Fee Amount</h2>
                                    <div className='w-100'>
                                        <Controller
                                            name="travel_fee_amount"
                                            control={control}
                                            render={({ field }) => (
                                                <input
                                                    className="input-in type_inp"
                                                    type="number"
                                                    name="travel_fee_amount"
                                                    placeholder="Travel Fee Amount"
                                                    {...field}
                                                    onChange={(e) => {
                                                        if (e.target.value.length <= 20) {
                                                            field.onChange(e);
                                                        }
                                                    }}
                                                />
                                            )}
                                        />
                                        {errors?.travel_fee_amount?.message && (
                                            <ErrorMessage
                                                text={errors?.travel_fee_amount?.message}
                                            />
                                        )}
                                    </div>
                                </div>
                                <div className="row-primary" style={{ alignItems: "center", marginTop: "15px" }}>
                                    <h2 style={{marginTop: "0px" }}>Travel Approved</h2>
                                    <div className='w-100' style={{ display: "flex", alignItems: "end" }}>
                                        <Controller
                                            name="travel_approved"
                                            control={control}
                                            required
                                            render={({ field }) => (
                                                <CustomSwitch
                                                    labelText="active"
                                                    checked={field.value == 1 ? true : false}
                                                    handleChange={(checked) => field.onChange(checked ? 1 : 0)}
                                                />
                                            )}
                                        />
                                    </div>
                                </div>
                            </>
                        )}
                        {requireAttestation && (
                            <div className="row-primary align-items-center encounter_switch" style={{ marginTop: "15px" }}>
                                <label className="custom-checkbox checkbox">
                                    <Controller
                                        name="attested"
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field }) => (
                                            <input
                                                type="checkbox"
                                                id="attested"
                                                name="attested"
                                                checked={field.value === 1 || field.value === true}
                                                onChange={(e) => field.onChange(e.target.checked ? 1 : 0)}
                                            />
                                        )}
                                    />
                                    <span className="checkmark"></span>
                                </label>
                                <label htmlFor="attested" className="labelTitle m-0" style={{ cursor: "pointer" }}>
                                    I certify that the check-in and check-out times reported above are true and correct.
                                </label>
                            </div>
                        )}
                        <div className="modal-body" style={{ paddingLeft: "0px" }}>
                            <SubmitButton
                                className="me-auto"
                                btnText="Submit"
                                buttonType="button"
                                loader={loader}
                                disabled={requireAttestation && !(watch("attested") === 1 || watch("attested") === true)}
                                handleSubmit={handleSubmit((data) => {
                                    console.log(item?.id)
                                    onSubmit({ ...data, id: item?.id }, "adjustment", handleCloseScheduleForm);
                                })}>
                                Submit Request
                            </SubmitButton>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
